module.exports = __webpack_public_path__ + "assets/img/vue_template_data_computed.fe13b4ff.jpg";